var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 26,
    width: 26,
    className: "lightbox-btn-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "lightbox-close-icon",
    cx: 13,
    cy: 13,
    r: 13
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 11,
    fill: "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "lightbox-close-icon",
    d: "M17.764 16.62l-1.144 1.144c-.158.157-.348.236-.573.236-.224 0-.415-.08-.572-.236L13 15.29l-2.475 2.474c-.157.157-.348.236-.572.236-.225 0-.415-.08-.573-.236L8.236 16.62C8.08 16.462 8 16.272 8 16.047c0-.224.08-.415.236-.572L10.71 13l-2.474-2.475C8.08 10.368 8 10.177 8 9.953c0-.225.08-.415.236-.573L9.38 8.236C9.538 8.08 9.728 8 9.953 8c.224 0 .415.08.572.236L13 10.71l2.475-2.474c.157-.157.348-.236.572-.236.225 0 .415.08.573.236l1.144 1.144c.157.158.236.348.236.573 0 .224-.08.415-.236.572L15.29 13l2.474 2.475c.157.157.236.348.236.572 0 .225-.08.415-.236.573z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.4a83e98e.svg";
export { ForwardRef as ReactComponent };